import { DataGridColSettings } from '@/components/DataGrid/utils';

export const masterAddressDataGridCols: DataGridColSettings[] = [
  {
    field: 'uniqueId',
    headerName: 'ID',
    width: 120,
    visible: true,
  },
  {
    field: 'addressLabel',
    headerName: 'Address',
    visible: true,
  },
  {
    field: 'subAddress',
    headerName: 'SubAddress',
    width: 200,
    visible: true,
  },
  {
    field: 'addressNotesCount',
    headerName: 'Address Notes',
    width: 120,
    visible: true,
  },
  {
    field: 'lastUpdated',
    headerName: 'Last updated',
    width: 180,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 96,
    visible: true,
  },
];

export const MasterAddressViewFields = [
  {
    title: 'Address Information',
    key: 'basic',
    size: { xs: 12, md: 6 },
    items: [{ label: 'Address', value: 'normalized' }],
  },
  {
    title: 'Additional Information',
    key: 'additional',
    size: { xs: 12, md: 6 },
    items: [
      { label: 'Status', value: 'status' },
      { label: 'Point Type', value: 'pointType' },
      { label: 'Address Notes', value: 'addressNotesCount' },
      { label: 'Created At', value: 'createdAt' },
      { label: 'Updated At', value: 'updatedAt' },
    ],
  },
  {
    title: 'Location Details',
    key: 'location',
    size: { xs: 12 },
    items: [
      { label: 'Coordinates', value: 'point' },
      { label: 'Intersection Streets', value: 'intersectionStreets' },
      { label: 'Cross Streets', value: 'crossStreets' },
      { label: 'Nearest Intersection', value: 'nearestIntersection' },
    ],
  },
];

export const MasterAddressFormFields = [
  {
    title: 'Address Information',
    name: '',
    items: [
      {
        name: 'address',
        label: 'Address',
        type: 'text',
        required: true,
        grid: { xs: 12, md: 12 },
      },
      {
        name: 'subAddress',
        label: 'SubAddress',
        type: 'text',
        grid: { xs: 12, md: 12 },
      },
    ],
  },
  {
    title: 'Address Notes',
    name: 'addressNotes',
    items: [
      {
        name: 'type',
        label: 'Type',
        type: 'select',
        required: true,
        options: [
          { label: 'Warning', value: 'warning' },
          { label: 'Notice', value: 'notice' },
          { label: 'Danger', value: 'danger' },
        ],
        grid: { xs: 12, md: 3 },
      },
      {
        name: 'comment',
        label: 'Comment',
        type: 'text',
        required: true,
        grid: { xs: 12, md: 6 },
      },
      {
        name: 'related',
        label: 'Related to',
        type: 'text',
        grid: { xs: 12, md: 3 },
      },
    ],
  },
];
